function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_FILETOURL_REQUEST = "POST_FILETOURL_REQUEST";
export var POST_FILETOURL_SUCCESS = "POST_FILETOURL_SUCCESS";
export var POST_FILETOURL_FAILURE = "POSTT_FILETOURL_FAILURE";
export var RESET_POST_FILETOURL = "RESET_POST_FILETOURL";
export var postFile = function postFile(file, uploadUrl, key, policy, signature, awsAccessKeyId, acl) {
  var body = new FormData();
  body.append("key", key);
  body.append("AWSAccessKeyId", awsAccessKeyId);
  body.append("acl", acl);
  body.append("policy", policy);
  body.append("signature", signature);
  body.append("file", file);
  return _defineProperty({}, CALL_API, {
    types: [POST_FILETOURL_REQUEST, POST_FILETOURL_SUCCESS, POST_FILETOURL_FAILURE],
    endpoint: uploadUrl,
    init: {
      method: "POST",
      body: body
    }
  });
};